// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2oYik","location":"Header_location__Q-3h9"};